<script setup>
const { modalType } = storeToRefs(useLayoutStore());
const { openLogin } = useAuth();
const { setAuthInitialTab } = useLayoutStore();

function openRegisterTab() {
  setAuthInitialTab('register');
  openLogin();
}
</script>

<template>
  <div
    v-if="modalType == 'login'"
    :class="$style.modalFooter"
  >
    <div class="text-auth-texts">
      {{ $t('auth.login.not_registered') }}
      <button
        class="text-auth-links"
        @click.prevent="openRegisterTab()"
      >
        {{ $t('auth.login.create_account') }}
      </button>
    </div>
  </div>

  <div
    v-else-if="modalType == 'register' || modalType == 'forgot-password'"
    :class="$style.modalFooter"
  >
    <div class="text-auth-texts">
      <button
        class="text-auth-links"
        @click.prevent="openRegisterTab()"
      >
        Voltar
      </button>
    </div>
  </div>
</template>

<style module lang="scss">
.modalFooter {
  @apply text-center text-xs mt-5 mb-0 pt-0;

  a,
  button {
    &:hover {
      @apply underline;
    }
  }
}
</style>
